import { SidebarWrapper } from '@components/common/SidebarWrapper/SidebarWrapper';
import { getArticleDates } from '@utils/getArticleDates';
import { buildArticleLink } from '@utils/link';
import NextLink from 'next/link';
import { Container, Heading, Text } from './ArticleLatestNews.styles';
import { ArticleLatestNewsProps } from './ArticleLatestNews.types';

export const ArticleLatestNews = ({ articles, heading }: ArticleLatestNewsProps) => {
  return (
    <SidebarWrapper heading={heading}>
      {articles?.map((article) => {
        const { publishedAt: publishedAtFormatted } = getArticleDates({
          publishedDate: article.publishedDate,
          publishedAt: article.publishedAt,
          updatedAt: article.updatedAt,
          dateFormat: 'd MMMM yyyy',
        });

        const subcategory = article.subcategories[0]?.name;

        return (
          <Container>
            <NextLink href={buildArticleLink(article.id, article.slug)} passHref>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a>
                <Heading>{article.title}</Heading>
              </a>
            </NextLink>
            <Text>
              {publishedAtFormatted} {subcategory ? `• ${subcategory}` : ''}
            </Text>
          </Container>
        );
      })}
    </SidebarWrapper>
  );
};
